import { render, staticRenderFns } from "./KeyMeasureTitle.vue?vue&type=template&id=37815c6e&"
import script from "./KeyMeasureTitle.vue?vue&type=script&lang=js&"
export * from "./KeyMeasureTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports